import { motion } from "framer-motion-3d"
import { useContext } from "react"

import AppContext from "../../hooks/AppConext"

const variants = {
  initial: { y: 0 },
  up: (coeff) => ({ y: 0.1 * coeff }),
  offset: (dist) => ({ y: -dist * 2.5 }),
}

export const StateWrapper = ({ name, children, ...props }) => {
  const { selected, hovered, setSelected, height, menuHovered } =
    useContext(AppContext)
  const handlePointerEnter = () => {}
  const handleClick = (e) => {
    selected === name ? setSelected(null) : setSelected(name)
    e.stopPropagation()
  }

  let animate
  if ([hovered, menuHovered, selected].includes(name)) {
    animate = "up"
  } else if (selected && selected !== name) {
    animate = "offset"
  }

  return (
    <motion.group
      name={name}
      variants={variants}
      animate={animate}
      custom={height * 0.75}
      transition={{ bounce: 0 }}
    >
      <group
        onPointerEnter={handlePointerEnter}
        onClick={handleClick}
        {...props}
      >
        {children}
      </group>
    </motion.group>
  )
}
